import { useEffect } from "react";
import { setDocTitle } from "../../../web_ui";
import { useCurrentGuildData } from "./use_guild_data";

export function useDocTitle(status: string) {
	const guild_data = useCurrentGuildData();

	useEffect(() => {
		const strings = [status];
		if (guild_data) {
			strings.push(guild_data.name);
		}

		setDocTitle(strings.join(" - "));
	}, []);
}
